import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon78: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 18.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 18 20" width={width} height={height} {...props}>
      <Path
        d="M7.86499 0.302512C8.56799 -0.101488 9.43199 -0.101488 10.136 0.302512L16.858 4.16851C17.564 4.57451 18 5.32649 18 6.14049V13.8595C18 14.6745 17.564 15.4265 16.858 15.8335L10.135 19.6985C9.43201 20.1015 8.56801 20.1015 7.86401 19.6985L1.14099 15.8325C0.434991 15.4265 0 14.6745 0 13.8595V6.14049C0 5.32749 0.434991 4.57451 1.14099 4.16851L7.86499 0.302512ZM16.989 5.97951L13.834 7.7195L13.835 11.5405C13.835 11.7865 13.658 11.9905 13.424 12.0325L13.334 12.0405C13.058 12.0405 12.834 11.8165 12.834 11.5405V8.27151L9.52701 10.0955L9.49701 18.9005L9.63699 18.8315L16.359 14.9665C16.755 14.7385 17 14.3165 17 13.8595V6.14049C17 6.08649 16.996 6.03251 16.989 5.97951ZM1.01199 5.9685C1.00399 6.0255 1 6.08249 1 6.14049V13.8595C1 14.3165 1.24501 14.7385 1.64001 14.9665L8.36301 18.8315C8.40701 18.8565 8.45201 18.8785 8.49701 18.8985L8.52701 10.0945L1.01199 5.9685ZM4.728 3.25851L1.64001 5.03451C1.60001 5.05751 1.56199 5.08249 1.52499 5.10949L9.02802 9.22951L12.303 7.4215L4.728 3.25851ZM9.63699 1.16952C9.24199 0.942516 8.75801 0.942516 8.36301 1.16952L5.74399 2.67449L13.34 6.84951L16.483 5.11651C16.48 5.11351 16.476 5.11149 16.473 5.10949L16.359 5.03551L9.63699 1.16952Z"
        fill="#404040"
      />
    </Icon>
  )
}
